<template>
  <div>
    <v-tooltip bottom>
      <slot slot="activator">
        <v-btn small icon @click="handleShowFormClick">
          <v-icon small>fa-undo</v-icon>
        </v-btn>
      </slot>
      Replace record
    </v-tooltip>

    <v-dialog
      v-model="showModal"
      max-width="800">
      <v-card v-if="showModal">
        <v-card-title class="headline">Service replacement</v-card-title>
        <v-card-text>
          2 log entries will be added. The 1st entry compensates for the existing log entry. The 2nd entry will add a new change.
        </v-card-text>
        <v-card-text>
          <service-select v-model="serviceId"/>
          <number-input v-model="quantityChange"
                        label="Change qty"
                        :min-value="-100"
                        :max-value="100"/>
          <v-text-field
            label="Comment"
            v-model="comment"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleSendForm">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {notificationService} from '../../../application'
    import ServiceSelect from '../../Ui/mcc/ServiceSelect'
    import NumberInput from '../../Ui/NumberInput'

    export default {
        name: 'replace-case-service-log-form',
        components: {
            ServiceSelect,
            NumberInput
        },
        props: {
            caseId: {
                type: String,
                required: true
            },
            id: {
                type: Number,
                required: true
            },
            currentServiceId: {
                type: String,
                required: true
            },
            currentQuantityChange: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                showModal: false,
                comment: '',
                serviceId: this.currentServiceId,
                quantityChange: this.currentQuantityChange
            }
        },
        computed: {},
        mounted() {
        },
        watch: {
            showModal() {
                if (!this.showModal) {
                    this.resetForm()
                }
            }
        },
        methods: {
            ...mapActions({
                replaceCaseServiceLog: 'replaceCaseServiceLog'
            }),
            handleShowFormClick() {
                this.showModal = true
            },
            handleSendForm() {
                this
                    .replaceCaseServiceLog({
                        caseId: this.caseId,
                        id: this.id,
                        comment: this.comment,
                        serviceId: this.serviceId,
                        quantityChange: this.quantityChange
                    })
                    .then(() => {
                        this.showModal = false
                    })
                    .catch(e => {
                        notificationService.error('Operation failed');
                        throw e
                    })
            },
            resetForm() {
                this.showModal = false;
                this.comment = '';
                this.serviceId = this.currentServiceId;
                this.quantityChange = this.currentQuantityChange
            },
            handleHideForm() {
                this.resetForm();
                this.showModal = false
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/ReplaceCaseServiceLogForm.vue